import React from 'react';

import EmojiIcon from './Emoji';

export const createEmojiIcon = (code: number) => {
  const EmojiComponent = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
    return <EmojiIcon code={code} {...props} />;
  };

  EmojiComponent.displayName = `EmojiIcon_${code}`;

  return EmojiComponent;
};
